<script lang="ts">
import { defineComponent, inject } from 'vue';

import { makeTagProps } from '../../composable';

import { CssGridSymbol, makeGridProps, makeSubgridProps, makeWideProps } from './composable';
import { CSSGrid } from './mode/CSSGrid';
import { FlexGrid } from './mode/FlexGrid';

export const componentName = 'CdsGrid';
export default defineComponent({
  name: componentName,
  props: {
    ...makeTagProps(),
    ...makeGridProps(),
    ...makeSubgridProps(),
    ...makeWideProps()
  },
  setup(props, context) {
    const enableCssGrid = inject(CssGridSymbol, false);
    return enableCssGrid ? CSSGrid(props, context) : FlexGrid(props, context);
  }
});
</script>
